module.exports = __webpack_public_path__ + "static/media/NAFIL_Pin.e4167f70.svg";